import { FC } from "react";
import { ReactTooltipStyled } from "components/atoms/Tooltip/Tooltip.styled";
import { Small, Span } from "utils/styling/typography.styled";
type EnhancedModelTooltipProps = {
  id: string;
  title: string;
  details: string[];
  isElite: boolean;
};
export const EnhancedModelTooltip: FC<EnhancedModelTooltipProps> = ({
  id,
  title,
  details,
  isElite
}) => {
  return <ReactTooltipStyled id={id} data-sentry-element="ReactTooltipStyled" data-sentry-component="EnhancedModelTooltip" data-sentry-source-file="index.tsx">
            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">{title}</Span>
            <br />
            <ul>
                {details.map((item, index) => <li key={index}>
                        <Small>{item}</Small>
                    </li>)}
            </ul>
            {!isElite && <>
                    <Span>Available for Elite Subscription Tier Only.</Span>
                </>}
        </ReactTooltipStyled>;
};